export default __webpack_public_path__ + "static/media/sketch12.1c8fd151.gif";